import type { BrandSwipeListProps } from '@/app/_components/widgets/brand-swipe/ui/brand-swipe-list/brand-swipe-list.types';
import type { FC, ReactNode } from 'react';
import { createContext, useContext } from 'react';

const BrandSwipeListContext = createContext<Partial<BrandSwipeListProps>>({
  items: [],
});

export const BrandSwipeProvider: FC<BrandSwipeListProps & { children: ReactNode }> = (props) => {
  return <BrandSwipeListContext.Provider value={props}>{props.children}</BrandSwipeListContext.Provider>;
};

export const useBrandSwipeProps = (): BrandSwipeListProps => {
  const context = useContext(BrandSwipeListContext);
  if (context === undefined) {
    throw new Error('useBrandSwipeProps must be used within a BrandSwipeProvider');
  }
  return context as BrandSwipeListProps;
};
